
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import news from "../../static/news/zhongwulian.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'4'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>深圳远东数智采技术服务有限公司董事长胡敏成一行到访中物联</h3>
          <div className='time'>发布时间：2025-11-16</div>
          <div className='newsCon-con'>
          <p>2025年11月10日，深圳市远东数智采技术服务有限公司董事长胡敏成一行到访中国物流与采购联合会，中国物流与采购联合会副会长何辉接待来访。</p>
          <p style={{textAlign:'center'}}><img src={news} /></p>
          <p>何辉代表中物联对胡敏成一行的到访表示欢迎，并系统介绍了中物联在推动采购规范创新发展、供应链优化及物流行业高质量发展等方面所开展的重点工作。他指出，当前数字技术正深刻重塑采购与供应链业态，中物联期待与像远东数智采这样具备技术实力和实践经验的企业加强交流，共同促进采购供应链领域的高质量发展。
          </p><p>胡敏成对中物联一直以来的支持表示感谢，他介绍了远东数智采公司近年来在数字化采购领域取得的发展成绩，特别介绍了企业在提供智能采购解决方案、公共采购大数据分析及数字化采购运营服务所做的努力和探索。</p>
          <p>在交流环节，双方围绕采购模式创新、专业人才培训以及行业高端会议合作等多个方向展开深入探讨。双方一致认为，在数字化采购快速发展的背景下，应进一步建立常态化互动机制，整合资源优势，共同推进采购供应链领域的生态共建与价值共享。</p>
          <p>远东数智采、中物联公共采购分会相关负责人参与交流。</p>
          </div>
        </div>
      </PageBox>
    </>
  );
}